module.exports = __webpack_public_path__ + "img/Image_logo_7.49192cf0.jpg";